<template>
	<div class="page">
		<gc-header headerData="batchImportTaskDetail"></gc-header>
		<div class="page-main task-details-main">
			<gc-group-detail :data="basicInfoData">
				<template #failFilePath>
					<p class="download-file-path" @click="handleDownloadFailFile">
						{{ taskDetails ? '下载' : '--' }}
					</p>
				</template>
			</gc-group-detail>
			<div class="task-details-table-show">
				<div class="table-header">设备列表</div>
				<div class="table-box">
					<div class="serach">
						<gc-custom-search
							class="search"
							key-word-width="121px"
							:key-word-option="keyWordOption"
							:key-word.sync="keyWord"
							:search.sync="form.key"
							width="320px"
						></gc-custom-search>
						<gc-custom-search
							class="search"
							key-word="设备状态"
							type="select"
							width="320px"
							:search-option="deviceStatusOptions"
							:search-option-key="{ label: 'name', value: 'defaultValue' }"
							:search.sync="form.deviceStatus"
							needAllForSearch
						></gc-custom-search>
						<gc-custom-search
							keyWord="任务状态"
							width="320px"
							type="select"
							:search.sync="form.taskStatus"
							:search-option="batchImportSubTaskStatusOptions"
							needAllForSearch
						></gc-custom-search>
						<div class="serach-ops">
							<el-button type="primary" @click="handleQuerySearch" v-click-blur>查询</el-button>
							<el-button v-click-blur @click="handleQueryReset">重置</el-button>
						</div>
					</div>
					<gc-table
						v-loading="loading"
						border
						showPage
						:columns="columns"
						:table-data="tableData"
						:current-page.sync="pagination.currentPage"
						:total="pagination.total"
						:pageSize="pagination.pageSize"
						gloabSortDisable
						paginationLayout="prev, next, jumper"
						@current-page-change="handleCurrentPageChange"
					></gc-table>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { isBlank } from '@/utils/validate'
import {
	apiGetBatchImportTaskDetails,
	apiGetBatchImportSubTaskList,
	apiDownloadFialSubTask,
} from '@/apis/batchImportTask.api'
import { batchImportSubTaskStatusOptions } from '@/config/const'
const optTypeMap = {
	0: '新增设备',
	1: '新增并安装设备',
	2: '仅安装设备',
	3: '更新设备',
}
export default {
	name: 'BatchImportTaskDetails',
	data() {
		return {
			taskId: this.$route.query.taskId,
			batchImportSubTaskStatusOptions,
			keyWordOption: [
				{
					label: '设备通讯编号',
					value: 'deviceNo',
				},
				{
					label: '外观编号',
					value: 'designNo',
				},
			],
			keyWord: 'deviceNo',
			form: {
				key: null,
				deviceStatus: null,
				taskStatus: null,
			},
			columns: [
				{
					key: 'deviceNo',
					name: '设备通讯编号',
					tooltip: true,
				},
				{
					key: 'designNo',
					name: '外观编号',
					tooltip: true,
				},
				{
					key: 'deviceStatus',
					name: '安装状态',
					render: (h, row) => {
						let val = row.deviceStatus
						let statusMap = {
							0: { class: 'dot-error', text: '待安装' },
							1: { class: 'dot-success', text: '已安装' },
							2: { class: 'dot-message', text: '已拆除' },
						}
						return h(
							'span',
							{ class: isBlank(val) ? '' : statusMap[val]['class'] },
							isBlank(val) ? '--' : statusMap[val]['text'],
						)
					},
				},
				{
					key: 'taskStatusName',
					name: '任务状态',
				},
				{
					key: 'failReason',
					name: '失败原因',
				},
				{
					key: 'createTime',
					name: '创建时间',
					width: 180,
				},
				{
					key: 'oprate',
					name: '操作',
					sortDisable: true,
					width: 130,
					fixed: 'right',
					render: (h, row) => {
						return h('div', {}, [
							row.taskStatus === 1
								? h(
										'el-button',
										{
											style: { color: '#4d6bff' },
											props: {
												type: 'text',
												size: 'medium',
											},
											on: {
												click: () => {
													this.$router.push({
														path: 'detail',
														query: {
															deviceId: row.deviceId,
															deviceType: row.deviceTypeId,
														},
													})
												},
											},
										},
										'查看详情',
								  )
								: '-',
						])
					},
				},
			],
			loading: false,
			pagination: {
				currentPage: 1,
				pageSize: 10,
				total: 0,
			},
			tableData: [],
			taskDetails: null,
			deviceStatusOptions: this.$store.getters?.dataList?.deviceStatus || [],
		}
	},

	created() {
		this.queryBatchImportTaskDetails()
		this.queryBatchImportSubTaskList()
	},

	methods: {
		/**
		 * 批量任务详情查询
		 */
		async queryBatchImportTaskDetails() {
			const data = await apiGetBatchImportTaskDetails({ taskId: this.taskId })
			this.taskDetails = data
		},

		/**
		 * 批量导入子任务列表数据查询
		 */
		async queryBatchImportSubTaskList() {
			this.loading = true
			const searchParams = {
				...this.form,
				[this.keyWord]: !isBlank(this.form.key) ? this.form.key : undefined,
				taskId: this.taskId,
				current: this.pagination.currentPage,
				size: this.pagination.pageSize,
				key: undefined,
			}
			try {
				const { records = [], total } = await apiGetBatchImportSubTaskList(searchParams)
				this.tableData = records
				this.pagination.total = total
			} finally {
				this.loading = false
			}
		},

		/**
		 * 失败任务明细Excel文件下载
		 */
		async handleDownloadFailFile() {
			if (!this.taskDetails?.failFilePath) return
			const data = await apiDownloadFialSubTask({ fileName: this.taskDetails.failFilePath })
			const blob = new Blob([data], { type: 'application/vnd.ms-excel' })
			const link = document.createElement('a')
			link.style.display = 'none'
			link.href = URL.createObjectURL(blob)
			link.download = '任务失败明细'
			document.body.appendChild(link)
			link.click()
			document.body.removeChild(link)
			this.$message.success('下载成功')
		},

		handleCurrentPageChange(current) {
			this.pagination.currentPage = current
			this.queryBatchImportSubTaskList()
		},

		handleQuerySearch() {
			this.pagination.currentPage = 1
			this.queryBatchImportSubTaskList()
		},

		handleQueryReset() {
			this.pagination.currentPage = 1
			for (const key in this.form) {
				this.form[key] = null
			}
			this.queryBatchImportSubTaskList()
		},
	},

	computed: {
		basicInfoData() {
			return {
				title: '任务属性',
				row: 4,
				list: [
					{
						key: 'taskName',
						label: '任务名称',
						value: this.taskDetails?.taskName,
					},
					{
						key: 'deviceTypeName',
						label: '设备类型',
						value: this.taskDetails?.deviceTypeName,
					},
					{
						key: 'optType',
						label: '操作类型',
						value: optTypeMap[this.taskDetails?.optType],
					},
					{
						key: 'taskStatusName',
						label: '任务状态',
						value: this.taskDetails?.taskStatusName,
					},
					{
						key: 'waitCount',
						label: '前方排队',
						value: this.taskDetails?.waitCount,
					},
					{
						key: 'importCount',
						label: '导入总数',
						value: this.taskDetails?.importCount,
					},
					{
						key: 'importWaitCount',
						label: '待执行数',
						value: this.taskDetails?.importWaitCount,
					},
					{
						key: 'importSuccessCount',
						label: '成功数',
						value: this.taskDetails?.importSuccessCount,
					},
					{
						key: 'importFailCount',
						label: '失败数',
						value: this.taskDetails?.importFailCount,
					},
					{
						key: 'createStaffName',
						label: '创建人',
						value: this.taskDetails?.createStaffName,
					},
					{
						key: 'createTime',
						label: '创建时间',
						value: this.taskDetails?.createTime,
					},
					this.taskDetails?.failFilePath
						? {
								key: 'failFilePath',
								label: '失败数据文件',
								value: this.taskDetails?.failFilePath,
								slot: 'failFilePath',
						  }
						: null,
					{
						key: 'remark',
						label: '备注',
						value: this.taskDetails?.remark,
						col: 4,
					},
				].filter(Boolean),
			}
		},
	},
}
</script>

<style lang="scss" scoped>
@import '../../run-manage/runLayout.scss';
.task-details-main {
	flex-direction: column;
	padding: 0 20px;
	.task-details-table-show {
		flex: 1;
		display: flex;
		flex-direction: column;
		height: 0;
		.table-header {
			font-size: 17px;
			font-weight: 600;
			color: #333333;
			padding-bottom: 20px;
		}
		.table-box {
			flex: 1;
			height: 0;
			display: flex;
			flex-direction: column;
			.serach {
				display: flex;
				flex-wrap: wrap;
				.serach-ops {
					::v-deep .el-button {
						border-radius: 8px;
					}
				}
				& > div {
					margin-right: 12px;
					margin-bottom: 8px;
				}
				.export-ops {
					margin-left: auto;
					margin-right: 0;
				}
			}
			::v-deep .gc-table {
				flex: 1;
				height: 0;
				margin-top: 8px;
			}
		}
	}
}
::v-deep .desc {
	.el-textarea.is-disabled .el-textarea__inner {
		border: 1px solid #d9d9d9;
		background: #ffffff !important;
		color: #4e4e4e;
	}
}

.download-file-path {
	color: #4d6bff;
	cursor: pointer;
	display: inline-block;
}
</style>
